/*
 * @Author: cheesekun
 * @Date: 2021-03-02 10:06:41
 * @LastEditors: cheesekun
 * @LastEditTime: 2021-03-02 10:33:13
 * @FilePath: \dc-important-act\src\components\Tip\tip.js
 */
import Notification from './notification.js'

let messageInstance

function getMessageInstance () {
  messageInstance = messageInstance || Notification.newInstance()
  return messageInstance
}

function notice ({ duration = 1.5, content = '' }) {
  const instance = getMessageInstance()

  instance.add({
    content: content,
    duration: duration
  })
}

export default {
  // 可以定义success warn
  info (options) {
    return notice(options)
  }
}
